import { Constants } from "../constants/Contants";
import request from "../utils/useApi";
import { get, post } from '../utils/request';

export const getAllFlights = async (data) => {
  try {
    const res = await request.post(`${Constants.get_all_flights_url}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
export const revalidateFlight = async (data) => {
  try {
    const res = await request.post(`${Constants.revalidate_flight_url}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
export const createPNRFlight = async (data) => {
  try {
    const res = await request.post(`${Constants.create_pnr_flight_url}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};
export const getTicketFlight = async (data) => {
  try {
    const res = await request.post(`${Constants.get_ticket_flight_url}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const requestFlightsPreorder = async (selectedPackage) => {
  try {
    const flightsPreorderResult = await post(Constants.flightsPreorder, selectedPackage);
    return flightsPreorderResult;
  } catch (error) {
    console.error("Failed to request flights preorder:", error);
    return null;
  }
};
